// HACK: does nothing, because `toPromise` now lives on the `Observable` itself.
// leaving this module here to prevent breakage.
//# sourceMappingURL=toPromise.js.map


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/rxjs/add/operator/toPromise.js
// module id = ../../../../rxjs/add/operator/toPromise.js
// module chunks = 4